/*
 *   File : active-sip.js
 *   Author : https://evoqins.com
 *   Description : Active SIP card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';

// Components
import { Chip } from "../Others";

//Style
import style from "../../Styles/Component/card.module.scss";
import { Icon } from '../Icon';


function WatchListCard(props) {

    const navigate = useNavigate();

    const _handleNavigateToDetail = (strategy_id) => {
        navigate("/explore/strategy-detail", {
            state: {
                strategy_id: Number(strategy_id)
            }
        })
    };

    return (
        <div className={`${style.e_alphabasket_card_wrapper} cursor-pointer`}
            onClick={() => _handleNavigateToDetail(props.product.strategy_id)}>
            <div className='e-bg-white border-radius-16'>
                <div data-type={props.product.strategy_type === "alpha-basket" ? "basket" : "basket-pro"}
                    className={`${style.e_heading_wrapper} position-relative`}>
                    <img src={require(props.product.strategy_type === "alpha-basket" ? "../../Assets/Images/Card/alphabasket-tag.svg" : "../../Assets/Images/Card/alphabasket-pro-tag.svg").default}
                        draggable={false}
                        className='position-absolute left--6px top-8px h-28'
                        alt='tag' />
                    {/* <Chip label={"Custom Low risk"}
                        className={props.product.strategy_name === 'Conservative' ? 'e-text-deep-green e-bg-nyanza e-border-1px-light-green' :
                            props.product.strategy_name === 'Moderate' ? 'e-text-brown e-bg-lemon-chiffon e-border-1px-jasmine' :
                                'e-text-cadmium-purple e-bg-lavender-blush e-border-1px-light-red'} /> */}
                </div>
                <div className='p-2 p-sm-3'>
                    <div className='d-flex align-items-center gap-12px pb-3 e-border-bottom-1px-anti-flash-white'>
                        <img src={props.product.strategy_icon}
                            draggable={false}
                            className='w-48px w-32px-res align-self-start border-radius-4 bg-white'
                            alt='product' />
                        <div className='d-flex flex-column gap-1'>
                            <p className='e-font-14-res mb-1 e-text-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px'>
                                {props.product.strategy_name}
                            </p>
                            <div className='d-flex gap-2'>
                                <p className='e-font-14-res mb-0 e-text-outer-space e-alt-font-lato e-font-16 e-font-weight-400 line-height-18px'>
                                    Objective :
                                </p>
                                <p className='e-font-14-res mb-0 e-text-outer-space e-alt-font-lato e-font-16 e-font-weight-400 line-height-18px'>
                                    {props.product.objective}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className='col-12 d-flex justify-content-between gap-4 mt-3'>

                        <div className="d-flex flex-column gap-2">
                            <p className='e-font-14-res mb-0 e-text-outer-space e-alt-font-lato e-font-16 e-font-weight-400 line-height-18px'>
                                Daily Change
                            </p>
                            <div className='d-flex gap-1 align-items-center'>
                                {/* <Icon icon={Number(props.product.daily_change) >= 0 ? "positive-arrow" : "negative-arrow"}
                                    className="d-flex w-20px" /> */}
                                <p className={`${Number(props.product.daily_change) >= 0 ? "positive-arrow" : "negative-arrow"} e-font-14-res mb-0 e-text-islamic-green e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px`}>
                                    {props.product.daily_change}%
                                </p>
                            </div>
                        </div>

                        <div className="d-flex flex-column gap-2">
                            <p className='e-font-14-res mb-0 e-text-outer-space e-alt-font-lato e-font-16 e-font-weight-400 line-height-18px'>
                                Returns
                            </p>
                            <span className={`${Number(props.product.returns) < 0 ? "e-text-red" : "e-text-islamic-green"} mb-1 e-font-14-res e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px`}>
                                {props.product.returns}%
                            </span>
                        </div>



                        <div className="d-flex flex-column gap-2">
                            <p className='e-font-14-res mb-0 e-text-outer-space e-alt-font-lato e-font-16 e-font-weight-400 line-height-18px'>
                                Returns Since
                            </p>
                            <span className={`e-text-outer-space mb-1 e-font-14-res e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px`}>
                                <span className='e-font-14 e-font-weight-600'>{props.product.returns_since}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(WatchListCard);